import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { Toaster } from 'sileo';
import { ThemeModeProvider, useThemeMode } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ProfilePage from './pages/ProfilePage';
import PatientsPage from './pages/PatientsPage';
import PatientDetailPage from './pages/PatientDetailPage';
import EvaluationsPage from './pages/EvaluationsPage';
import EvaluationDetailPage from './pages/EvaluationDetailPage';
import EvaluationMatrixPage from './pages/EvaluationMatrixPage';

function AppShell() {
  const { mode } = useThemeMode();

  return (
    <>
      <CssBaseline />
      <Toaster position="top-center" theme={mode} options={{ duration: 4000 }} />
      <Router>
        <Routes>
          {/* Ruta por defecto - redirigir al login */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* Página de login - pública */}
          <Route path="/login" element={<LoginPage />} />

          {/* Dashboard - protegida */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <DashboardPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Perfil - protegida */}
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Layout>
                  <ProfilePage />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Pacientes - protegida */}
          <Route
            path="/patients"
            element={
              <ProtectedRoute>
                <Layout>
                  <PatientsPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Detalle del Paciente - protegida */}
          <Route
            path="/patients/:id"
            element={
              <ProtectedRoute>
                <Layout>
                  <PatientDetailPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Evaluaciones - protegida */}
          <Route
            path="/evaluations"
            element={
              <ProtectedRoute>
                <Layout>
                  <EvaluationsPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Matriz de Conversión - protegida */}
          <Route
            path="/evaluations/matrix"
            element={
              <ProtectedRoute>
                <Layout>
                  <EvaluationMatrixPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Detalle de Evaluación - protegida */}
          <Route
            path="/evaluations/:evaluationId"
            element={
              <ProtectedRoute>
                <Layout>
                  <EvaluationDetailPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Ruta catch-all - redirigir al login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <ThemeModeProvider>
        <AppShell />
      </ThemeModeProvider>
    </AuthProvider>
  );
}

export default App;
